import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import laptopImg from "../../Assets/favrhood_app.png";
import SupportCard from "./SupportCard";
import SupportStack from "./SupportStack";


function Support() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
            Support <strong className="purple">Choicest Fruit </strong>
            </h1>
            <SupportCard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
      
       

        <h1 className="project-heading">
          <strong className="purple">Our</strong> Partners
        </h1> 
        <SupportStack />

      
      </Container>
    </Container>
  );
}

export default Support;
